import {
  HubConnectionBuilder,
  HubConnection,
  LogLevel,
} from "@microsoft/signalr";

export const createSignalRConnection = (hubUrl: string): HubConnection => {
  const connection = new HubConnectionBuilder()
    .withUrl(`https://marathon-app.timelysoft.org${hubUrl}`, {
      accessTokenFactory: () => localStorage.getItem("AccessToken") || "",
    })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Information)
    .build();

  connection
    .start()
    .then((): void => {
      console.log(`✅ Connected to ${hubUrl}`);
      // alert(`✅ Handshake успешен с ${hubUrl}`);
    })
    .catch((error: any) => {
      console.error("SignalR Connection Error:", error);
      // alert(`❌ Ошибка соединения с ${hubUrl}`);
    });

  connection.onclose((err) => {
    console.warn(`⚠️ Соединение с ${hubUrl} закрыто`, err);
    // alert(`⚠️ Соединение с ${hubUrl} закрыто`);
  });

  connection.onreconnecting((err) => {
    console.log(`🔄 Пытаемся переподключиться к ${hubUrl}`, err);
  });

  connection.onreconnected((connectionId) => {
    console.log(`♻️ Переподключение к ${hubUrl} успешно`, connectionId);
    // alert(`♻️ Переподключение к ${hubUrl} успешно`);
  });


  return connection;
};